import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const EditDealSubtypeMasterPage = withSuspense(lazy(() => import('./edit-deal-subtype-master-page')));
export default EditDealSubtypeMasterPage;
